// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import getColor from "@insite/mobius/utilities/getColor";
import { miniCartStyles } from "@sc/App/Components/MiniCart/MiniCart";
import { createHorizontalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import { styledScrollbar } from "@sc/XDL/Utilities";
import { css } from "styled-components";

miniCartStyles.miniCartWrapper = {
    css: css`
        height: 100%;
        max-height: 100%;
        display: flex;
        flex-direction: column;
    `,
};
miniCartStyles.productsWrapper = {
    css: css`
        padding: 12px 4px 0 12px;
        max-height: calc(100vh - 103px);
        overflow: hidden;
        margin-bottom: 6px;
    `,
};
miniCartStyles.cartLinesWrapper = {
    css: css`
        position: relative;
        overflow-x: hidden;
        width: calc(100% - 4px);
        padding-right: 4px;
        max-height: calc(100vh - 118px);
        ${styledScrollbar(4, 0)}
    `,
};

miniCartStyles.summarySectionWrapper = {
    css: css`
        position: sticky;
        bottom: 0;
        right: 0;
        background-color: ${getColor("common.background")};
        z-index: 1;
        flex: 1 1 0%;
        max-height: 103px;
        padding: 12px;
        box-shadow: 0 -1px 0 0 ${getColor("common.ui3")};
    `,
};

miniCartStyles.infoWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 13px;
        height: 22px;
    `,
};

miniCartStyles.miniCartInfoSubTotal = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                justify-content: flex-end;
            `,
        },
        heading: {
            size: 14,
            weight: 400,
            css: css`
                line-height: 22px;
            `,
        },
        text: {
            size: 18,
            weight: "bold",
            css: css`
                line-height: 24px;
            `,
        },
    }),
};

miniCartStyles.miniCartInfoItem = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                justify-content: baseline;
            `,
        },
        heading: {
            size: 14,
            weight: "bold",
            css: css`
                line-height: 22px;
            `,
        },
        text: {
            size: 14,
            weight: 400,
            css: css`
                line-height: 22px;
            `,
        },
    }),
};
miniCartStyles.actionWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 13px;
    `,
};

miniCartStyles.checkoutButton = {
    sizeVariant: "large",
    mergeCss: true,
    typographyProps: {
        lineHeight: "16px",
    },
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};

miniCartStyles.viewCartButton = {
    sizeVariant: "large",
    variant: "tertiary",
    mergeCss: true,
    typographyProps: {
        lineHeight: "16px",
    },
    css: css`
        flex: 1 1 0%;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};

miniCartStyles.centerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        min-width: 250px;
        min-height: 200px;
        justify-content: center;
    `,
};

miniCartStyles.notify = {
    css: css`
        margin-bottom: 12px;
    `,
};

miniCartStyles.emptyCartWrapper = {
    css: css`
        padding: 17px;
    `,
};
